<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import {decode, encode} from "../../../helpers";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const karniz_dop = options.karniz_dop || [
        '101 белый',
        '17 коричневый',
        '1854 графит глянец',
        '187 зеленый',
        '207 розовый',
        '26 салатный',
        '264 зеленый гладкий металлик',
        '308 желтый',
        '330 абрикос',
        '410 т-бежевый',
        '412 кофе с молоком',
        '415 бежевый',
        '44 красный',
        '491 синий зернистый металлик',
        '517 синий',
        '519 зеленый',
        '615 голубой',
        '7144 сирень гладкий металлик',
        '814 черный',
        '84 лазурь',
        '908 золото зернистый металлик',
        '937 серебро зернистый металлик'
    ]
    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch();
            width.set(json.width)
            height.set(json.height)
            ind2 = json.ind2
            ind4 = json.ind4
            sideControl = json.sideControl
            system = json.system
            opcii = json.opcii
            dvaizd = json.dvaizd
            fikstros = json.fikstros
            lenti = json.lenti
            kursDollara = json.kursDollara

            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const fetch = async (system = 'Горизонт Магнум 25мм') => {
        let result = await network.fetch_data('Магнум', system);
        let filtered = result.filter(el => el.name.startsWith('Горизонт Магнум') && el.flag === '1')

        return {
            name: _.groupBy(result, 'name'),
            color_cornice: Array.from(new Set(filtered.map(el => el.ind2.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            color_tape: Array.from(new Set(filtered.map(el => el.ind3.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            options,
            result,
        }
    }

    let
        width = parameter('width', '270'),
        height = parameter('height', '1400'),

        ind2 = '101 (белый)', // цвет
        ind4 = '101 белый',
        sideControl = 'Слева',
        system = 'Горизонт Магнум 25мм',
        dvaizd = 'Нет',
        fikstros = 'Нет',
        lenti = 'Нет',
        opcii = 'Держатель нижнего карниза(фнк)',
        kursDollara = '70',
        povish = 1,

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch(system);

    /* let
         montage_item,
         montage_price = 1;*/

    let c_options_v1 = {
        'Свободновисящие': 'Свободновисящие',
        'Держатель нижнего карниза(фнк)': 'ФНК',
        'Держатель нижнего карниза магнитный': 'Магнит'
    }
    let c_options_v2 = {
        'Держатель леска': 'Леска',
    }
    $: c_options = (system === 'Горизонт Магнум 25мм' ? c_options_v1 : c_options_v2)

    const changeInd1 = async () => {
        fetchData = await fetch(system);
        opcii = Object.keys(c_options)?.[0] ?? ''

        change();

    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'жалюзи-магнум',
            name: 'Жалюзи Магнум',
            subname: [
                $width + 'x' + $height, ', Цвет ленты * 25 мм - ', ind2, ', Цвет карниза - ', ind4, ', Сторона управления - ', sideControl, ', ', opcii, (dvaizd == 'Да' ? ', Два изделия на 1 карнизе' : ''), (fikstros == 'Да' ? ', Фиксация трос' : ''), (lenti != 'Нет' ? ', ' + lenti : '')

            ].join(''),
            title: [
                'Жалюзи ', system, ' ', $width + 'x' + $height, ', Цвет ленты * 25 мм - ', ind2, ', Цвет карниза - ', ind4, ', Сторона управления - ', sideControl, ', ', opcii, (dvaizd == 'Да' ? ', Два изделия на 1 карнизе' : ''), (fikstros == 'Да' ? ', Фиксация трос' : ''), (lenti != 'Нет' ? ', ' + lenti : '')

            ].join(''),
            params: {
                ind1: [ind4, ' ', sideControl, ' ',
                    system, ' ',
                    opcii, ' ',
                    dvaizd].join(''),
                ind2: ind2,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    ind2,
                    ind4,
                    sideControl,
                    system,
                    opcii,
                    dvaizd,
                    fikstros,
                    lenti,
                    kursDollara,
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 110
        };

        kursDollara = parseInt(data.result.find((item) => item.name === 'Курс доллара')?.sebestomost ?? 0);


        if (lenti == "2 ленты в полотне") {
            povish = 1.3;
        } else if (lenti == "Нет") {
            povish = 1;
        } else {
            povish = 1.5;
        }

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;
            let vibind4 = ''

            if (ind4.toLowerCase().includes('белый')) {
                vibind4 = 'Белый'
            } else if (ind4.toLowerCase().includes('графит')) {
                vibind4 = 'Графит'
            } else {
                vibind4 = 'Магнум'
            }


            if (name.startsWith(system.toLowerCase())) {
                if (item.ind2 == vibind4 && item.ind3 == ind2) {
                    kolvo = w * h / 1000000;

                    if (kolvo < 0.8) {
                        kolvo = 0.8
                    }

                }
            } else if (name.includes("Держатель нижнего карниза(фнк)".toLowerCase())) {
                if (opcii == "Держатель нижнего карниза(фнк)") {
                    kolvo = 1;
                } else {
                    kolvo = 0;

                }
            } else if (name.includes("Держатель нижнего карниза магнитный".toLowerCase())) {
                if (opcii == "Держатель нижнего карниза магнитный") {
                    kolvo = 2;
                } else {
                    kolvo = 0;
                }
            } else if (name.includes("Фиксация трос".toLowerCase())) {
                if (fikstros == "Нет") {
                    kolvo = 0;
                } else {
                    kolvo = 1;
                }
            } else if (name.includes("Два изделия на 1 карнизе".toLowerCase())) {
                if (dvaizd == "Нет") {
                    kolvo = 0;
                } else {
                    kolvo = 1;
                }
            } else if (name.includes("Боковая фиксация на леске".toLowerCase())) {
                if (opcii == "Держатель леска") {
                    kolvo = 1;
                } else {
                    kolvo = 0;
                }
            } else {
                kolvo = +item.kolvo;

            }

            if (kolvo) {

                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * kursDollara * povish * (+item.flag));
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * kursDollara * povish * (+item.flag));
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * kursDollara);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price * kursDollara).toFixed(2),
                        opt: (+item.opt_price * kursDollara).toFixed(2),
                        sebest: (+item.sebestomost * kursDollara).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            /*  if (name.includes('монтаж')) {
                  montage_item = item;
              }*/
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        /*let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
        dispatch('mounting', {item: montage_item, price: montage_price});*/


        dispatch('item', result);
    }, 250);

    change();

    $: computedValue = sideControl.includes("Слева")
        ?  "https://225304.selcdn.ru/axisdb/magnum_r_20251029092907.png"
        : "https://225304.selcdn.ru/axisdb/magnum_left_20251029092856.png"  ;

</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.color_cornice, null, 4)}</pre>-->

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-6">


                <div class="row">
                    <div class="col-12">
                        <div class="alert alert-outline-info fade show text-center" role="alert">Курс доллара: $1
                            = {kursDollara}₽
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Система</label>
                                <select class="form-control form-select" bind:value={system}
                                        on:change={() => {changeInd1(); }}>
                                    <option value="Горизонт Магнум тень 25мм">Горизонт Магнум тень 25мм</option>
                                    <option value="Горизонт Магнум 25мм">Горизонт Магнум 25мм</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет ленты * 25 мм</label>
                                <select class="form-control form-select" bind:value={ind2}>
                                    {#each data.color_tape as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет карниза</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#each karniz_dop as value}
                                        <option value="{value}">{value}</option>
                                    {/each}

                                    <!--  {#each data.color_cornice as value}
                                          <option value="{value}">{value}</option>
                                      {/each}-->
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> {  ($width > (system == 'Горизонт Магнум 25мм' ? 2000 : 2000) || $width < (system == 'Горизонт Магнум 25мм' ? 270 : 270) || $height > (system == 'Горизонт Магнум 25мм' ? 2500 : 2000) || $height < (system == 'Горизонт Магнум 25мм' ? 300 : 300)) ? 'Изделие с данными размерами не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase mt-2"> {  ((system == 'Горизонт Магнум 25мм' ? 2500000 : 2500000) < $height * $width) ? 'Не подлежит гарантии, так как ' + ($height * $width / 1000000).toString() + ' м² больше 2,5 м² максимальной площади' : '' }</span>
                </div>
                <div class="row">

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">250 ≥ Шир., мм ≥ 2500</label>
                                <input type="number"
                                       class="form-control text-center { ($width > (system == 'Горизонт Магнум 25мм' ? 2500  : 2500) || $width < (system == 'Горизонт Магнум 25мм' ? 250  : 250) ||  (system == 'Горизонт Магнум 25мм' ? 2500000 : 2500000) < $height * $width ) ? 'text-danger' : '' }"
                                       step="1"
                                       min="250"
                                       max="60000"
                                       bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Выс., мм ≥ 2500</label>
                                <input type="number"
                                       class="form-control text-center { ($height > (system == 'Горизонт Магнум 25мм' ? 2500  : 2500) || $height < (system == 'Горизонт Магнум 25мм' ? 300  : 300) ||  (system == 'Горизонт Магнум 25мм' ? 2500000 : 2500000) < $height * $width ) ? 'text-danger' : '' }"
                                       step="1"
                                       min="300"
                                       max="30000"
                                       bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">


                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Сторона управления</label>
                                <select class="form-control form-select" bind:value={sideControl}>
                                    <option value="Слева">Слева</option>
                                    <option value="Справа">Справа</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Опции</label>
                                <select class="form-control form-select" bind:value={ opcii }>
                                    {#each Object.entries(c_options) as [key, value]}
                                        <option value="{key}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Два изделия на 1 карнизе</label>
                                <select class="form-control form-select" bind:value={ dvaizd }>
                                    <option value="Нет">Нет</option>
                                    <option value="Да">Да</option>

                                </select>

                            </div>
                        </div>
                    </div>


                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Несколько лент</label>
                                <select class="form-control form-select" bind:value={ lenti }>
                                    <option value="Нет">Нет</option>
                                    <option value="2 ленты в полотне">2 ленты</option>
                                    <option value="3 ленты в полотне">3 ленты</option>
                                    <option value="4 ленты в полотне">4 ленты</option>
                                    <option value="5 лент в полотне">5 лент</option>
                                    <option value="6 лент в полотне">6 лент</option>
                                    {#if lenti === '2 ленты в полотне'}
                                        <label class="form-label">+30%</label>
                                    {:else if lenti !== 'Нет'}
                                        <label class="form-label">+50%</label>
                                    {:else }
                                        <label class="form-label"> </label>
                                    {/if}

                                </select>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-sm-6 text-center d-flex order-last flex-column order-sm-first justify-content-around">
                {#if system }
                    <img src={`${computedValue}`} alt={system} title={system} style="max-height: 300px;"/>
                    <div class="text-center">
                        <span class="form-label text-center">Площадь:
                            {  Math.max($width * $height / 1000000, 0.8).toFixed(2) } м.кв.</span>
                    </div>
                {/if}
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


